import React from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { makeStyles } from "@material-ui/core";
import { Button } from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import styles from "assets/jss/vivoleo-react-kit/views/componentsSections/addRecordScreenStyle";

const useStyles = makeStyles(styles);

export const ExportToExcel = ({ apiData, fileName }) => {
  const classes = useStyles();
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Button
      variant="outlined"
      className="medium"
      startIcon={<ArticleIcon className={classes.vivoblueColor} />}
      onClick={(e) => exportToCSV(apiData, fileName)}
    >
      Export To Excel File
    </Button>
  );
};
